/* ALGEA — contact-lens prescription picker (W27, owner 2026-10-06).
   snippets/algea-cl-options.liquid renders the picker beside the buy buttons; it must sit inside the
   product form so the chosen powers are posted with add-to-cart as line-item properties (the theme
   submits new FormData(form)). This script moves it there, keeps it in step with the selected
   variant (ColourVue: power only for "Me numër"; box size per variant) and stops add-to-cart until a
   required power is chosen.
   Different prescriptions become OD and OS lines in one product-form request, preserving the
   theme's validation, cart events and bundled section rendering. */
(() => {
  var AT = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };
  const FORM = 'form[data-type="add-to-cart-form"]';
  const EYES = { both: AT('Të dy sytë'), right: AT('Syri i djathtë (OD)'), left: AT('Syri i majtë (OS)') };

  const readJson = (el) => {
    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (error) {
      return null;
    }
  };

  function currentVariantId(form) {
    const input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : '';
  }

  function place() {
    const form = document.querySelector(FORM);
    if (!form) return null;
    const pickers = Array.from(document.querySelectorAll('[data-algea-cl-rx]'));
    const inside = pickers.find((p) => form.contains(p));
    pickers.forEach((p) => {
      if (p === inside) return;
      if (inside) {
        p.remove(); // a re-render brought a fresh copy; keep the one holding the customer's choices
      } else {
        form.insertBefore(p, form.querySelector('.product-form-buttons'));
      }
    });
    return form;
  }

  const twoEyes = (picker) => {
    const box = picker && picker.querySelector('[data-cl-two-eyes]');
    return Boolean(box && box.checked);
  };

  function applyEyes(picker) {
    if (!picker) return;
    const two = twoEyes(picker);
    const second = picker.querySelector('[data-cl-eye="2"]');
    const title = picker.querySelector('[data-cl-eye1-title]');
    const label = picker.querySelector('[data-cl-eye-label]');
    if (second) second.hidden = !two;
    if (title) title.hidden = !two;
    if (label) label.value = two ? EYES.right : EYES.both;
  }

  function sync() {
    const form = place();
    if (!form) return;
    const id = currentVariantId(form);
    const root = document.querySelector('[data-algea-cl]');
    const needs = readJson(root && root.querySelector('[data-cl-variants]'));
    const picker = form.querySelector('[data-algea-cl-rx]');
    if (picker && needs && id in needs) {
      picker.disabled = !needs[id];
      picker.hidden = !needs[id];
    }
    applyEyes(picker);
    const boxes = readJson(root && root.querySelector('[data-cl-boxes]'));
    const boxCell = root && root.querySelector('[data-cl-box]');
    // Compare first: rewriting identical text is still a DOM mutation and would re-trigger the observer.
    if (boxes && boxCell && boxes[id] && boxCell.textContent !== boxes[id]) boxCell.textContent = boxes[id];
  }

  function missing(form) {
    const picker = form.querySelector('[data-algea-cl-rx]');
    if (!picker || picker.disabled) return null;
    const required = Array.from(picker.querySelectorAll('[data-cl-required]'));
    if (twoEyes(picker)) required.push(...picker.querySelectorAll('[data-cl-required2]'));
    return required.find((s) => !s.value) || null;
  }

  function showError(form, text) {
    const error = form.querySelector('[data-cl-error]');
    if (!error) return;
    if (text) error.textContent = text;
    error.hidden = !text;
  }

  function guard(event) {
    const form = event.target.closest ? event.target.closest(FORM) : null;
    if (!form) return;
    if (form.dataset.clPending) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const empty = missing(form);
    if (empty) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form, AT('Zgjidhni dioptrinë përpara se ta shtoni në shportë.'));
      empty.focus();
      if (empty.reportValidity) empty.reportValidity();
      return;
    }
    showError(form, '');
    const picker = form.querySelector('[data-algea-cl-rx]');
    // The product form owns the request and cart events. Snapshot both prescriptions
    // before a variant response can replace the picker or the customer's selections.
    form.algeaContactLensItems = (item) => {
      if (!picker || picker.disabled || !twoEyes(picker)) return [item];
      const properties = { ...item.properties, Syri: EYES.left };
      picker.querySelectorAll('[data-cl-eye="2"] [data-cl-prop]').forEach((select) => {
        properties[select.dataset.clProp] = select.value;
      });
      return [{ ...item, properties: { ...item.properties, Syri: EYES.right } }, { ...item, properties }];
    };
  }

  const schedule = () => window.setTimeout(sync, 60);

  // Capture phase on document runs before the theme's own submit / click handlers.
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest(`${FORM} [type="submit"]`);
    if (button) guard({ target: button, preventDefault: () => event.preventDefault(),
      stopImmediatePropagation: () => event.stopImmediatePropagation() });
  }, true);
  document.addEventListener('change', (event) => {
    const picker = event.target.closest && event.target.closest('[data-algea-cl-rx]');
    if (picker) {
      if (event.target.matches('[data-cl-two-eyes]')) applyEyes(picker);
      const form = event.target.closest(FORM);
      if (form && !missing(form)) showError(form, '');
      return;
    }
    schedule();
  });
  document.addEventListener('click', schedule);

  const start = () => {
    sync();
    const details = document.querySelector('[data-algea-cl]');
    const host = details && details.closest('product-information, .product-information, main');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
